import { openBlock as d, createElementBlock as h, normalizeStyle as g, createElementVNode as v, renderSlot as i } from "vue";
import { _ as b } from "../_plugin-vue_export-helper-dad06003.js";
import { w } from "../util-b2b0dc25.js";
const D = {
  name: "rDraggable",
  props: {
    /**
     * 移动检测，入参是{left,top}偏移信息的对象，返回同样的对象，表示要偏移的位置
     */
    moveChange: {
      type: Function,
      default: null
    },
    /**
     * 位移X，值改变会触发moveChange规则
     */
    translateX: {
      type: Number,
      default: 0
    },
    /**
     * 位移Y, 值改变会触发moveChange规则
     */
    translateY: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      left: 0,
      top: 0
    };
  },
  methods: {
    mouseUp() {
    },
    onMouseDown(e) {
      const o = e.clientX, s = e.clientY, a = this.left, r = this.top, n = (m) => {
        const f = m.clientX - o, p = m.clientY - s, c = a + f, u = r + p;
        let t = {
          left: c,
          top: u
        };
        if (t = this.moveChange ? this.moveChange(t) : t, typeof t == "object") {
          if (!t.left && t.left !== 0)
            throw new Error("偏移信息缺少 left 属性");
          if (!t.top && t.top !== 0)
            throw new Error("偏移信息缺少 top 属性");
          this.left = t.left, this.top = t.top;
        }
      }, l = () => {
        document.removeEventListener("mousemove", n), document.removeEventListener("mouseup", l);
      };
      return document.addEventListener("mousemove", n), document.addEventListener("mouseup", l), !1;
    }
  },
  mounted() {
  },
  watch: {
    translateX(e, o) {
      if (this.moveChange) {
        const { left: s } = this.moveChange({
          left: e,
          top: this.top
        });
        this.left = s;
      } else
        this.left = e;
    },
    translateY(e, o) {
      if (this.moveChange) {
        const { top: s } = this.moveChange({
          left: this.left,
          top: e
        });
        this.top = s;
      } else
        this.top = e;
    }
  }
};
function E(e, o, s, a, r, n) {
  return d(), h(
    "div",
    {
      class: "r-draggable",
      style: g(`transform:translate(${r.left}px,${r.top}px)`)
    },
    [
      v(
        "div",
        {
          class: "r-draggable-head",
          onMousedown: o[0] || (o[0] = (...l) => n.onMouseDown && n.onMouseDown(...l))
        },
        [
          i(e.$slots, "dragBar")
        ],
        32
        /* HYDRATE_EVENTS */
      ),
      i(e.$slots, "default")
    ],
    4
    /* STYLE */
  );
}
const C = /* @__PURE__ */ b(D, [["render", E], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/draggable/draggable.vue"]]), M = w(C);
export {
  M as default
};
